<script>
  import { MaxNumberOfTableLogs } from "../../../Utils/utilConstants.svelte";

  export let row = {},
    fromTable = false,
    fullWidthDisplay = false,
    col = {};

  export let changeList = [],
    trimmed = false;

  $: if (row?.changes) {
    try {
      changeList = JSON.parse(row.changes);
      if (changeList.length) {
        changeList.forEach((c) => (c.Field = c.Field.replaceAll(".", " ")));
      }
      trimChangeList();
    } catch (error) {
      if (row.changes && row.changes[0] && typeof row.changes[0] === "object") {
        changeList = row.changes;
        trimChangeList();
      } else {
        changeList = [];
      }
    }
  }

  const trimChangeList = () => {
    if (changeList.length > MaxNumberOfTableLogs && fromTable) {
      changeList = changeList.slice(0, MaxNumberOfTableLogs);
      trimmed = true;
    }
  };
</script>

{#if changeList.length}
  <div class="flex flex-col flex-1">
    {#each changeList as change}
      <div class="grid grid-cols-12 py-2 items-start logs-item">
        <span
          class="break-words whitespace-pre-wrap text-left mr-2 {fullWidthDisplay
            ? 'col-span-4'
            : 'col-span-7'}"
        >
          {change.Field ?? ""}
        </span>
        <div
          class="flex flex-row {fullWidthDisplay ? 'col-span-6' : 'col-span-5'}"
        >
          <span
            class="break-all text-end whitespace-pre-wrap opacity-80 flex-1"
          >
            {change.From ?? "-"}
          </span>
          <span class="mx-[12px]">
            <i class="fa fa-arrow-right" aria-hidden="true" />
          </span>
          <span class="break-all text-start whitespace-pre-wrap flex-1">
            {change.To ?? ""}
          </span>
        </div>
      </div>
    {/each}
    {#if trimmed && fromTable}
      <span
        class="text-secondary col-span-9 cursor-pointer decoration-solid pt-2"
        >see more</span
      >
    {/if}
  </div>
{:else}
  -
{/if}

<style>
  .logs-item + .logs-item {
    border-top: 1px solid #e5e7eb;
  }
</style>
